import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faUser, faBook,faQuoteRightAlt,faSlidersH,faOm,faList12,faBookOpen, faImage } from '@fortawesome/free-solid-svg-icons';
import useAuth from '../../hooks/useAuth'

const LeftNavigation = () => {
    const { id, isManager, isAdmin } = useAuth()
  return (
    <>
         <ul className="navigation">
            <li>
              <Link to="/dashboard/users">
                <FontAwesomeIcon icon={faUser} color='#ff0000' />
                <span>Users</span>
              </Link>
            </li>
            <li>
              <Link to="/dashboard/events">
                <FontAwesomeIcon icon={faCalendar} />
                <span>Events</span>
              </Link>
            </li>
            {/* <li>
              <Link to="/dashboard/bhajans">
                <FontAwesomeIcon icon={faBook} />
                <span>Bhajans</span>
              </Link>
            </li> */}
            <li>
              <Link to="/dashboard/quotes">
                <FontAwesomeIcon icon={faQuoteRightAlt} />
                <span>Quotes</span>
              </Link>
            </li>
            <li>
              <Link to="/dashboard/meditation">
                <FontAwesomeIcon icon={faOm} />
                <span>Meditation</span>
              </Link>
            </li>
            <li>
              <Link to="/dashboard/carousel">
                <FontAwesomeIcon icon={faSlidersH} />
                <span>Carousel</span>
              </Link>
            </li>
            <li>
              <Link to="/dashboard/categories">
                <FontAwesomeIcon icon={faList12} />
                <span>Categories</span>
              </Link>
            </li>
            <li>
              <Link to="/dashboard/contents">
                <FontAwesomeIcon icon={faBookOpen} />
                <span>Contents</span>
              </Link>
            </li>
            <li>
              <Link to="/dashboard/gallery">
                <FontAwesomeIcon icon={faImage} />
                <span>Gallery</span>
              </Link>
            </li>
            <li>
              <Link to="/dashboard/gallery-categories">
                <FontAwesomeIcon icon={faImage} />
                <span>Gallery Categories</span>
              </Link>
            </li>
            <li>
              <Link to="/dashboard/gallery-events">
                <FontAwesomeIcon icon={faImage} />
                <span>Gallery Events</span>
              </Link>
            </li>
          </ul>
    </>
  )
}

export default LeftNavigation